import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentosPoderesService {

  documentosGet$ = new BehaviorSubject(null);
  documentosGetBin$ = new BehaviorSubject(null);
  documentosPost$ = new BehaviorSubject(null);
  documentosPut$ = new BehaviorSubject(null);
  documentosDelete$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  //Buscar Documentos
  get(id_cliente) {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/CadastroPoderes/ObterDocumentoCliente/" + id_cliente + "/" + environment.empresa;

      this.http.get(url).subscribe({
        next: (data) => this.documentosGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.documentosGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.documentosGet$.unsubscribe(),
          this.documentosGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Buscar Documentos
  getBin(id_documento) {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/CadastroPoderes/ObterArquivoDocumento/" + id_documento + "/" + environment.empresa;

      this.http.get(url).subscribe({
        next: (data) => this.documentosGetBin$.next(data),
        error: (error: HttpErrorResponse) => {
          this.documentosGetBin$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.documentosGetBin$.unsubscribe(),
          this.documentosGetBin$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Incluir Documento
  post(documento: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/CadastroPoderes/IncluirDocumentoCliente"
      documento.empresa = environment.empresa;

      this.http.post(url, documento, { headers: headers })
        .subscribe({
          next: (res: any) => this.documentosPost$.next(res),
          error: (error: HttpErrorResponse) => {
            this.documentosPost$.next(false);
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.documentosPost$.unsubscribe(),
            this.documentosPost$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Alterar Documento
  put(documento: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/CadastroPoderes/EditarDocumentoCliente"
      documento.empresa = environment.empresa;

      this.http.put(url, documento, { headers: headers })
        .subscribe({
          next: (res: any) => this.documentosPut$.next(res),
          error: (error: HttpErrorResponse) => {
            this.documentosPut$.next(false);
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.documentosPut$.unsubscribe(),
            this.documentosPut$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Deletar Documento
  del(documento: any) {
    try {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: documento
      };

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/CadastroPoderes/ExcluirDocumentoCliente"
      documento.empresa = environment.empresa;

      this.http.delete(url, options).subscribe({
        next: (res: any) => this.documentosDelete$.next(res),
        error: (error: HttpErrorResponse) => {
          this.documentosDelete$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.documentosDelete$.unsubscribe(),
          this.documentosDelete$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }
}
